import { VALUATIONS_SPREADSHEET_APPROACH_TABLE_NAME_REGEX } from 'pages/ValuationsAllocation/common/constants/valuations';

// Resolves which known table (approach, summary, ...) a sheet belongs to. Sheet names are
// "<table name>_<suffix>", and table names can start with "_" (names starting with a digit)
// or contain "_" themselves, so match the known names first and only then fall back to the regex.
const getInvalidSheetTableName = (sheetName: string, tableNames: string[]): string => {
  const matchingTableName = tableNames
    .filter(tableName => sheetName === tableName || sheetName.startsWith(`${tableName}_`))
    .sort((a, b) => b.length - a.length)[0];

  if (matchingTableName) {
    return matchingTableName;
  }

  return VALUATIONS_SPREADSHEET_APPROACH_TABLE_NAME_REGEX.exec(sheetName)?.[1] ?? sheetName;
};

export default getInvalidSheetTableName;
